import {Button, Col, Row, Spinner, Tab, Tabs, Toast} from "react-bootstrap";
import './ControlUnitsPage.css';
import ControlUnitConfigPage from "./ControlUnitConfigPage";
import CredentialsPage from "./CredentialsPage";
import React, {useContext, useEffect, useState} from "react";
import {ControlUnitService} from "./ControlUnitService";
import {Link, useParams, useLocation} from "react-router-dom";
import SshPage from "./SshPage";
import {store} from "../../Store/store";
import OptionsPage from "./OptionsPage";
import {AGGREGATED_DATA_INTERVAL_MAX, AGGREGATED_DATA_INTERVAL_MIN, AGGREGATED_DATA_RESOLUTION_MAX, AGGREGATED_DATA_RESOLUTION_MIN, CONNECTED, KEEP_ALIVE_INTERVAL_MAX, KEEP_ALIVE_INTERVAL_MIN} from "./Types";
import {RingSpinnerOverlay} from "react-spinner-overlay";
import {SET_CU_DETAILS, SET_LAST_CONTROL_UNIT_TIME_INTERVAL} from "../../Store/ActionTypes/General/actionTypes";
import UpgradePage from "./UpgradePage";
import {VscSettings} from "react-icons/vsc";
import {HiOutlineTerminal} from "react-icons/hi";
import {MdOutlineUpgrade, MdOutlineVpnKey} from "react-icons/md";
import {RiErrorWarningLine} from "react-icons/ri";
import {IoIosArrowBack} from "react-icons/io";
import {BsCheckCircleFill} from "react-icons/bs";
import {BiCog} from "react-icons/bi";
import {snakeCaseToNormalString} from "../../General/SharedMethods";
import {ProvisioningService} from "./provisioningService";
import {useHistory} from 'react-router-dom';
import greenCircle from "../../Images/green-circle.png";
import redCircle from "../../Images/red-circle.png";
import CustomIcon from "../../Components/CustomIcon/CustomIcon";
import OverviewPage from "./OverviewPage";
import {PiBinocularsFill} from "react-icons/pi";
import moment from "moment/moment";

const lifecyclePhaseLabels = {
    'ENROLLED': 'Enrolled',
    'PRE_SERVICE': 'Pre-Service',
    'IN_SERVICE': 'In-Service',
    'INTERNAL_USE': 'Internal Use',
    'DECOMMISSIONED': 'Decommissioned',
    'HARDWARE_DONOR': 'Hardware Donor',
};

function ControlUnitsDetailsPage({
                                     data,
                                     setData
                                 }) {
    const [isCopied, setIsCopied] = useState(false);
    const [controlUnitNameValue, setControlUnitNameValue] = useState('');
    const [controlUnitSerialNumber, setControlUnitSerialNumber] = useState('');
    const [keepAliveInterval, setKeepAliveInterval] = useState();
    const [aggregatedDataInterval, setAggregatedDataInterval] = useState();
    const [aggregatedDataResolution, setAggregatedDataResolution] = useState();
    const [logLevel, setLogLevel] = useState();
    const [lifecyclePhase, setLifecyclePhase] = useState();
    const {controlUnitId} = useParams();
    const location = useLocation();
    const fromPage = new URLSearchParams(location.search).get('page');
    const controlUnitService = new ControlUnitService(process.env.REACT_APP_SUPPORT_DASHBOARD_CONTROL_UNITS_URL);
    const [controlUnitDetails, setControlUnitDetails] = useState({});
    const [vmaData, setVmaData] = useState([]);
    const [isOkClicked, setIsOkClicked] = useState(false);
    const [isApplyingActive, setIsApplyingActive] = useState(false);
    const [isUpdateDetailsRequestInProgress, setIsUpdateDetailsRequestInProgress] = useState(false);
    const [metersData, setMetersData] = useState([]);
    const [valvesData, setValvesData] = useState([]);
    const [waterSystemData, setWaterSystemData] = useState([]);
    const [controlUnitConfigurationVersion, setControlUnitConfigurationVersion] = useState(null);
    const [controlUnitStateVersion, setControlUnitStateVersion] = useState(null);
    const [isNoWaterSystems, setIsNoWaterSystems] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const [showErrorModal, setShowErrorModal] = useState(false);
    const [tabSelected, setTabSelected] = useState('Configuration');
    const POLLING_TIME_INTERVAL = 5000;
    const [lastTimeInterval, setLastTimeInterval] = useState(0);
    const [isPollingActive, setIsPollingActive] = useState(true);
    const stateObj = useContext(store);
    const {dispatch} = useContext(store);
    const controlUnitPageLastTimeInterval = stateObj.state.lastControlUnitTimeInterval;
    const provisioningService = new ProvisioningService(process.env.REACT_APP_SUPPORT_DASHBOARD_PROVISIONING_URL);
    const [credentialsData, setCredentialsData] = useState([]);
    const [isNoCredentials, setIsNoCredentials] = useState(false);
    const [connectionState, setConnectionState] = useState(null);
    const [hardwareVersion, setHardwareVersion] = useState(null);
    const [lastUpdated, setLastUpdated] = useState(null);
    const [lastUpdatedSiteTime, setLastUpdatedSiteTime] = useState(null);
    const [shouldReload, setShouldReload] = useState(false);
    const history = useHistory();

    const copyTextToClipboard = async (text) => {
        setIsCopied(true);
        if ('clipboard' in navigator) {
            return await navigator.clipboard.writeText(text);
        } else {
            // For old browsers
            return document.execCommand('copy', true, text);
        }
    }

    const setStateLastTimeInterval = (timeInterval) => {
        dispatch({
            type: SET_LAST_CONTROL_UNIT_TIME_INTERVAL, payload: timeInterval
        });
    }

    const getCurrentVmaState = (vma) => {
        const currentVma = stateObj.state.vmaListArr.filter((obj) => obj.uuid === vma.uuid);
        return currentVma[0];
    }

    const getControlUnitDetails = async () => {
        try {
            const response = await controlUnitService.getControlUnitDetails(controlUnitId);
            if (!response) {
                console.error(`Data from Control Unit Details is empty`);
                setIsNoWaterSystems(true);
                setIsUpdateDetailsRequestInProgress(false);
                return;
            }
            updateControlUnitDetailsState(response);
            setIsUpdateDetailsRequestInProgress(false);
        } catch (err) {
            console.error(err);
            setIsNoWaterSystems(true);
            setIsUpdateDetailsRequestInProgress(false);
        }
    }

    function removeUsernameAndPassword(obj) {
        const filteredObj = {};

        for (const key in obj) {
            if (key !== 'username' && key !== 'password' && obj[key]) {
                filteredObj[key] = obj[key];
            }
        }
        return filteredObj;
    }

    const getCredentialsData = async (controlUnitDmiSerialNumber) => {
        try {

            const response = await provisioningService.getCredentials(controlUnitDmiSerialNumber);
            if (!response) {
                console.error(`Data from get credentials is empty`);
                setIsNoCredentials(true);
                return;
            }
            Object.entries(response.data).length > 0 ? setIsNoCredentials(false) : setIsNoCredentials(true);
            let key = 0;
            let credentials = Object.entries(response.data).map(([section, value]) => {
                return {
                    id: key,
                    type: snakeCaseToNormalString(section),
                    username: value?.username || "",
                    password: value?.password || "",
                    remainingFields: removeUsernameAndPassword(value)
                }
            })
            credentials = credentials.filter(obj => !(obj.username === '' && obj.password === '' && JSON.stringify(obj.remainingFields) === '{}'));
            setCredentialsData(credentials);
        } catch (error) {
            console.error(error);
            setIsNoCredentials(true);
        }

    }

    const checkWaterSystemData = (updatedControlUnitDetails) => {
        if (updatedControlUnitDetails.data.waterSystems) {
            setWaterSystemData(updatedControlUnitDetails.data.waterSystems)
            updatedControlUnitDetails.data.waterSystems.length === 0 ? setIsNoWaterSystems(true) : setIsNoWaterSystems(false);
        } else {
            setIsNoWaterSystems(true);
            setWaterSystemData([]);
        }
    }

    const updateControlUnitDetailsState = async (updatedControlUnitDetails) => {
        setControlUnitConfigurationVersion(updatedControlUnitDetails.data.configurationVersion);
        setControlUnitStateVersion(updatedControlUnitDetails.data.stateVersion);
        setVmaData(updatedControlUnitDetails.data.vmas ? updatedControlUnitDetails.data.vmas : []);
        checkWaterSystemData(updatedControlUnitDetails);
        setConnectionState(updatedControlUnitDetails.data.connectionState);
        setHardwareVersion(updatedControlUnitDetails.data.hwVersion);
        await getCredentialsData(updatedControlUnitDetails.data.dmiSerialNumber);
        setControlUnitDetails(updatedControlUnitDetails.data);
        setValvesData(updatedControlUnitDetails.data.valves ? updatedControlUnitDetails.data.valves : []);
        setMetersData(updatedControlUnitDetails.data.meters ? updatedControlUnitDetails.data.meters : []);
        setControlUnitNameValue(updatedControlUnitDetails.data.name ? updatedControlUnitDetails.data.name : '');
        setControlUnitSerialNumber(updatedControlUnitDetails.data.serialNumber ? updatedControlUnitDetails.data.serialNumber : '');
        setKeepAliveInterval(updatedControlUnitDetails.data.keepAliveInterval)
        setAggregatedDataInterval(updatedControlUnitDetails.data.aggregatedDataInterval)
        setAggregatedDataResolution(updatedControlUnitDetails.data.aggregatedDataResolution)
        setLogLevel(updatedControlUnitDetails.data.logLevel)
        setLifecyclePhase(updatedControlUnitDetails.data.lifecyclePhase)
        setLastUpdated(updatedControlUnitDetails.data.connectionStateUpdatedAt);
        setLastUpdatedSiteTime(updatedControlUnitDetails.data.connectionStateUpdatedAtSiteTime);
    }

    const handleOk = async () => {
        setIsOkClicked(true);
        await handleApply();
        history.push(fromPage ? `/controlUnits?page=${fromPage}` : '/controlUnits');
    }

    const handleApply = async () => {
        let newControlUnitDetails = controlUnitDetails;
        newControlUnitDetails.name = controlUnitNameValue;
        newControlUnitDetails.keepAliveInterval = keepAliveInterval;
        newControlUnitDetails.aggregatedDataInterval = aggregatedDataInterval;
        newControlUnitDetails.aggregatedDataResolution = aggregatedDataResolution;
        newControlUnitDetails.logLevel = logLevel;
        newControlUnitDetails.lifecyclePhase = lifecyclePhase;
        setIsApplyingActive(true);
        setIsUpdateDetailsRequestInProgress(true);
        try {
            const updateControlUnitDetailsResponse = await controlUnitService.updateControlUnitDetails(controlUnitId, newControlUnitDetails);
            setIsUpdateDetailsRequestInProgress(false);
            if (!updateControlUnitDetailsResponse) {
                setIsUpdateDetailsRequestInProgress(false);
                console.error(`Data from get Updated Control unit details is empty`);
                return;
            }
            setTimeout(() => {
                setIsApplyingActive(false);
            }, 1000)
            updateControlUnitDetailsState(updateControlUnitDetailsResponse);
        } catch (err) {
            setShouldReload(true);
            setErrorMessage('Changes were not applied since you were not using the latest configuration version, reload the page?');
            setShowErrorModal(true);
            setIsApplyingActive(false);
            setIsUpdateDetailsRequestInProgress(false);
        }

    }

    const handleCancel = () => {
        history.push(fromPage ? `/controlUnits?page=${fromPage}` : '/controlUnits');
    }

    const isApplyingDisabled = () => {
        return !(keepAliveInterval >= KEEP_ALIVE_INTERVAL_MIN &&
            keepAliveInterval <= KEEP_ALIVE_INTERVAL_MAX &&
            aggregatedDataInterval >= AGGREGATED_DATA_INTERVAL_MIN &&
            aggregatedDataInterval <= AGGREGATED_DATA_INTERVAL_MAX &&
            aggregatedDataResolution >= AGGREGATED_DATA_RESOLUTION_MIN &&
            aggregatedDataResolution <= AGGREGATED_DATA_RESOLUTION_MAX);
    }


    const renderConnectivityStatus = () => {
        const isConnected = connectionState === CONNECTED;
        const lastUpdatedAt = lastUpdated ? moment(lastUpdated).format('lll') : 'N/A';
        const lastUpdatedAtSiteTime = lastUpdatedSiteTime ? moment(lastUpdatedSiteTime).format('lll') : 'N/A';
        return (
            <div style={{display: 'flex', alignItems: 'center'}}>
                <div style={{marginRight: '5px'}}><strong>Connectivity:</strong></div>
                <div>
                    {isConnected ? <CustomIcon
                            className={'mb-1'}
                            width={17}
                            height={17}
                            src={greenCircle}
                            alt={"greenCircle"}/> :
                        <CustomIcon
                            className={'mb-1'}
                            width={17}
                            height={17}
                            src={redCircle}
                            alt={"redCircle"}/>}
                </div>
                <div style={{marginRight: '5px'}}></div>
                <div className={'mr-1 '}>{isConnected ? 'Connected' : 'Disconnected'} </div>
                <div> Since: {lastUpdatedAt} (Browser Time) | {lastUpdatedAtSiteTime} (System Time)</div>
            </div>
        );
    };

    const renderButtons = () => {
        const buttons =
            <Row className='ml-5 mt-3'>
                <Col md={{span: 0.5, offset: 10}}>
                    <Button disabled={isApplyingDisabled()} onClick={handleOk} className={'mr-2'} style={{width: 80}}>OK </Button>
                </Col>
                <Col md={0.5}>
                    <Button onClick={handleCancel} className={'mr-2'} style={{width: 80}}>
                        Cancel
                    </Button>
                </Col>
                <Col md={0.5}>
                    <Button disabled={isApplyingDisabled()} onClick={handleApply} className={'mr-2'} style={{width: 80}}>Apply</Button>
                </Col>
            </Row>
        switch (tabSelected) {
            case 'Configuration':
                return buttons;
            case 'Settings':
                return buttons;
            case 'Credentials':
                return null;
            case 'SSH':
                return null;
            case 'Upgrade':
                return null;
            case 'Overview':
                return null;
            default:
                return buttons;
        }
    }
    useEffect(() => {
        dispatch({
            type: SET_CU_DETAILS, payload: controlUnitDetails
        });
    }, [controlUnitDetails])

    useEffect(() => {
        clearInterval(controlUnitPageLastTimeInterval);
        getControlUnitDetails();
    }, [])

    useEffect(() => {
        if (isPollingActive && controlUnitConfigurationVersion && controlUnitStateVersion) {
            clearInterval(lastTimeInterval);
            const timeInterval = setInterval(async () => {
                try {
                    const response = await controlUnitService.isControlUnitDataChanged(controlUnitId, controlUnitConfigurationVersion, controlUnitStateVersion);
                    if (response.data === true) {
                        const response = await controlUnitService.getControlUnitDetails(controlUnitId);
                        const configVersion = response.data.configurationVersion;
                        if (configVersion === controlUnitConfigurationVersion) {
                            // Handling only state changes in the code below
                            setControlUnitStateVersion(response.data.stateVersion);
                            setVmaData(vmaData.map(vma => {
                                const updatedVma = response.data.vmas.find(newVma => newVma.uuid === vma.uuid);
                                return updatedVma ? {...vma, pairingState: updatedVma.pairingState} : vma;
                            }));
                            setMetersData(metersData.map(meter => {
                                const updatedMeter = response.data.meters.find(newMeter => newMeter.uuid === meter.uuid);
                                return updatedMeter ? {...meter, connectivityStatus: updatedMeter.connectivityStatus} : meter;
                            }));
                            setValvesData(valvesData.map(valve => {
                                const updatedValve = response.data.valves.find(newValve => newValve.uuid === valve.uuid);
                                return updatedValve ? {...valve, connectivityStatus: updatedValve.connectivityStatus} : valve;
                            }));
                        }
                    }

                } catch (e) {
                    console.error(e);
                }
            }, POLLING_TIME_INTERVAL);
            setStateLastTimeInterval(timeInterval);
            setLastTimeInterval(timeInterval)
        } else {
            clearInterval(lastTimeInterval);
        }
    }, [isPollingActive, controlUnitConfigurationVersion, controlUnitStateVersion, vmaData, metersData, metersData])

    return (
        <>
            <RingSpinnerOverlay
                loading={isApplyingActive}
                message={isOkClicked ? 'Saving...' : 'Applying..'}
                color='rgb(0,123,255)'
            />
            <Toast
                autohide={true}
                delay={3000}
                show={isCopied}
                onClose={() => setIsCopied(false)}
                style={{
                    position: 'absolute',
                    bottom: '5%',
                    right: '45%',
                    margin: '5px',
                    animation: true,
                    backgroundColor: 'white',
                    zIndex: 100
                }}>
                <Toast.Body><BsCheckCircleFill className='mr-2 mb-1' color={'green'} size={25}/> Copied To Clipboard</Toast.Body>
            </Toast>
            <div>
                <div style={{position: 'absolute', top: 80, paddingBottom: 36, marginTop: 0, zIndex: 1}}>
                    <div className={'d-inline-block mr-2'}><Button className={'p-0 m-0'} variant='link'><Link style={{color: 'black'}} to={fromPage ? `/controlUnits?page=${fromPage}` : '/controlUnits'}><IoIosArrowBack size={30}/></Link></Button></div>
                    <div className={'d-inline-block mr-3'}><b>Control Unit Name:</b></div>
                    <div className={'d-inline-block'}><input value={controlUnitNameValue} onChange={(e) => setControlUnitNameValue(e.target.value)} style={{width: 600}}/></div>
                </div>
                <div style={{position: 'absolute', top: 115, marginLeft: 40, display: 'flex', gap: '20px', fontSize: '14px', zIndex: 1}}>
                    <span><strong>CU ID:</strong> {controlUnitId}</span>
                    <span><strong>Lifecycle:</strong> {lifecyclePhaseLabels[lifecyclePhase] || lifecyclePhase || 'N/A'}</span>
                </div>
                {connectionState ? <div style={{position: 'absolute', top: 140, marginLeft: 40, zIndex: 2}}>{renderConnectivityStatus()}</div> : null}
                <div style={{ position: 'relative'}}>
                    <Tabs onSelect={(eventKey) => {
                        setTabSelected(eventKey);
                    }} style={{marginLeft: 800, paddingLeft: 40}} defaultActiveKey="Configuration">
                        <Tab eventKey="Overview" title={<span>Overview <PiBinocularsFill className={'mt-3 mb-3'} size={20}/></span>}>
                            <div style={{height:'80vh', overflowY:'auto'}}>
                                <OverviewPage cuNameValue={controlUnitNameValue}
                                              controlUnitSerialNumber={controlUnitSerialNumber}
                                              hardwareVersion={hardwareVersion}
                                              controlUnitId={controlUnitId}
                                              connectionState={connectionState}
                                />
                            </div>
                        </Tab>
                        <Tab tabClassName='cuConfigTab' eventKey="Configuration" title={<span>Configuration <BiCog className={'mt-3 mb-3'} size={20}/></span>}>
                            <div style={{height:'80vh' ,overflowY:'auto'}}>
                            <ControlUnitConfigPage data={data}
                                                   vmaData={vmaData}
                                                   dispatch={dispatch}
                                                   setIsUpdateDetailsRequestInProgress={setIsUpdateDetailsRequestInProgress}
                                                   updateCuDetailsState={updateControlUnitDetailsState}
                                                   setData={setData}
                                                   controlUnitId={controlUnitId}
                                                   cuNameValue={controlUnitNameValue}
                                                   setCuNameValue={setControlUnitNameValue}
                                                   copyTextToClipboard={copyTextToClipboard}
                                                   controlUnitService={controlUnitService}
                                                   setVmaData={setVmaData}
                                                   errorMessage={errorMessage}
                                                   setShowErrorModal={setShowErrorModal}
                                                   showErrorModal={showErrorModal}
                                                   isApplyingActive={isApplyingActive}
                                                   isPollingActive={isPollingActive}
                                                   setIsPollingActive={setIsPollingActive}
                                                   isOkClicked={isOkClicked}
                                                   isUpdateDetailsRequestInProgress={isUpdateDetailsRequestInProgress}
                                                   isNoWaterSystems={isNoWaterSystems}
                                                   waterSystemData={waterSystemData}
                                                   metersData={metersData}
                                                   valvesData={valvesData}
                                                   handleOk={handleOk}
                                                   handleCancel={handleCancel}
                                                   handleApply={handleApply}
                                                   renderButtons={renderButtons}
                                                   connectionState={connectionState}
                                                   shouldReload={shouldReload}
                                                   controlUnitDetails={controlUnitDetails}
                                                   setControlUnitDetails={setControlUnitDetails}
                            />
                                </div>
                        </Tab>
                        <Tab title={isApplyingDisabled() ? <span>Settings <VscSettings className={'mt-3 mb-3'} size={20}/> <RiErrorWarningLine className={'mt-3 mb-3'} size={20} color={'red'}/></span> : <span>Settings <VscSettings className={'mt-3 mb-3'} size={20}/></span>} eventKey="Settings">
                            <OptionsPage
                                controlUnitId={controlUnitId}
                                controlUnitService={controlUnitService}
                                isApplyingActive={isApplyingActive}
                                isOkClicked={isOkClicked}
                                keepAliveInterval={keepAliveInterval}
                                aggregatedDataResolution={aggregatedDataResolution}
                                aggregatedDataInterval={aggregatedDataInterval}
                                logLevel={logLevel}
                                setAggregatedDataInterval={setAggregatedDataInterval}
                                setAggregatedDataResolution={setAggregatedDataResolution}
                                setKeepAliveInterval={setKeepAliveInterval}
                                setLogLevel={setLogLevel}
                                lifecyclePhase={lifecyclePhase}
                                setLifecyclePhase={setLifecyclePhase}
                            />
                        </Tab>
                        <Tab eventKey="Upgrade" title={<span>Upgrade<MdOutlineUpgrade className={'mt-3 mb-3'} size={25}/></span>}>
                            <UpgradePage
                                controlUnitId={controlUnitId}
                                isApplyingActive={isApplyingActive}
                                isOkClicked={isOkClicked}
                                keepAliveInterval={keepAliveInterval}
                                aggregatedDataResolution={aggregatedDataResolution}
                                aggregatedDataInterval={aggregatedDataInterval}
                                logLevel={logLevel}
                                setAggregatedDataInterval={setAggregatedDataInterval}
                                setAggregatedDataResolution={setAggregatedDataResolution}
                                setKeepAliveInterval={setKeepAliveInterval}
                                setLogLevel={setLogLevel}
                            />
                        </Tab>
                        <Tab eventKey="Credentials" title={<span>Credentials <MdOutlineVpnKey className={'mt-3 mb-3'} size={20}/></span>}>
                            <CredentialsPage controlUnitId={controlUnitId}
                                             copyTextToClipboard={copyTextToClipboard}
                                             credentialsData={credentialsData}
                                             isNoCredentials={isNoCredentials}
                            />
                        </Tab>
                        <Tab eventKey="SSH" title={<span>SSH <HiOutlineTerminal className={'mt-3 mb-3'} size={20}/></span>}>
                            <SshPage copyTextToClipboard={copyTextToClipboard} controlUnitId={controlUnitId} controlUnitService={controlUnitService}/>
                        </Tab>
                    </Tabs>

                </div>
                {tabSelected !== 'Configuration' ? renderButtons() : null}
            </div>
        </>
    )
}

export default ControlUnitsDetailsPage;
